var _ = require('underscore');
var moment = require('moment');
var SecureMessageView = require('./../secure-message/SecureMessageView');
var secureMessageReceiptTemplate = require('./secureMessageReceiptTemplate.hbs');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');

/**
 * @class SecureMessageReceiptView
 * @constructor
 * @param option {Object}
 *   @param options.model {Torso.Model}
 *   @param options.context.patientVecnaId {String}
 */
module.exports = SecureMessageView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--border brec-list__item--multi-linked',
  template: secureMessageReceiptTemplate,

  behaviors: {
    refunds: {
      behavior: SecureMessageDataBehavior,
      updateEvents: ['model:change:refundReceiptVecnaIds'],
      ids: function(cache) {
        var receipt = this.view.model;
        var refundReceiptVecnaIds = receipt.get('refundReceiptVecnaIds');
        if (_.isEmpty(refundReceiptVecnaIds)) {
          return [];
        }
        var criteria = {
          isPatient: true,
          vecnaIds: [this.view._patientVecnaId],
          receiptCriteria: {
            messageVecnaIds: receipt.get('refundReceiptVecnaIds')
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    }
  },

  prepareFields: {
    new: function() {
      var transactionTime = this.model.get('timestamp');
      return moment(transactionTime).isSame(Date.now(), 'day');
    },
    uniqueAccounts: function() {
      var paymentDetails = this.model.get('payment.paymentDetails');
      var allAccountNumbers = _.pluck(paymentDetails, 'account');
      return _.uniq(allAccountNumbers);
    }
  },

  /**
   * Adds attributes to the the top level element (this is to support existing behavioral tests that query these values).
   * This only works because, as an item view, this view will only be created when the model already exists.  Values will not
   * be updated dynamically if they change for this view after it renders.
   * @returns {{receipt-vecna-id: String}} the receipt's Vecna id.
   */
  attributes: function() {
    return {
      'receipt-vecna-id': this.model.get('vecnaId'),
      'data-test-receipt-item': true
    };
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    SecureMessageView.prototype.initialize.apply(this, arguments);
    this.listenTo(this.getBehavior('refunds'), 'fetched', this.render);
  }
});
